import { render, staticRenderFns } from "./EvolucionIngresoMuestras.vue?vue&type=template&id=2c0f4a92&scoped=true&"
import script from "./EvolucionIngresoMuestras.vue?vue&type=script&lang=js&"
export * from "./EvolucionIngresoMuestras.vue?vue&type=script&lang=js&"
import style0 from "./EvolucionIngresoMuestras.vue?vue&type=style&index=0&id=2c0f4a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f4a92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VSkeletonLoader})
